import * as xlsx from "xlsx"
import { SheetData, SheetRow } from "../interfaces/dataInterfaces"

export async function getJsonFromXlsx(file: File) {
  const data = await file.arrayBuffer()
  const workbook = xlsx.read(data, { type: "array" })
  const sheetData: SheetData[] = []

  workbook.SheetNames.forEach(sheet => {
    const workSheet = workbook.Sheets[sheet]
    const json = xlsx.utils.sheet_to_json(workSheet, { defval: "" })

    const header: SheetRow = []
    if (json?.length) {
      Object.keys(json[0] as Record<string, any>)?.forEach(key => {
        if (!key.includes("__EMPTY")) {
          header.push({
            value: key,
            readOnly: false,
          })
        }
      })
    }

    const workBookData: SheetRow[] = [header]

    json.forEach(row => {
      const rowData: SheetRow = [
        ...Object.values(row as Record<string, any>).map(key => ({
          value: key,
          readOnly: false,
        })),
      ]

      workBookData.push(rowData)
    })

    sheetData.push({
      name: sheet,
      data: workBookData,
    })
  })

  return sheetData
}
